"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var Spacing = {
  Base: '8px',
  Medium: '16px',
  Large: '24px',
  Close: '16px',
  Separate: '40px',
  sidebarWidth: '324px' // 300px + Space.Large
};
var _default = Spacing;
exports["default"] = _default;